module.exports = __webpack_public_path__ + "static/EagleProject-18d664b0c84ae008347187796e84c44f.jpg";